import frUtils from '../util/frUtils';

(function ($) {

    $.fn.funder = function () {

        return this.each((index, block) => {
            const $self = $(block);
            let $funderPageContainer = $('.funder_logo_carousel');

            //funder bio popup
            $funderPageContainer.on('click', '.funder-modal-link', function (e) {
                e.preventDefault();
                
                var dataUrl = $(this).attr('data-url');
                frUtils.setUrlHash(dataUrl);

                var funderId = $(this).attr('id');
                funderDataBio(funderId, $self);
            });

            $('.funder_logo_carousel .logo-img').each(function () {
                var dataUrl = $(this).attr('data-url');
                if (dataUrl === frUtils.urlHashValue) {
                    $(this).trigger('click');
                    return false;
                }
            });

        });
    }

    function funderDataBio(funderId, $block) {
        $($block).find('.ajax-loading').addClass('wrap-loading');
        $($block).find('.ajax-loading').show();
        let $modalId = $block.attr('data-modal');
        let $modal = $($block).find('#' + $modalId);

        $.frAjax({
            action: 'funderBio',
            data: {
                funderId: funderId,
            },
        })
            .then(data => {
                
                $($modal[0]).find('.modal-body').html(data);
                $.frModalOpen($modal[0]);
                $($block).find('.ajax-loading').removeClass('wrap-loading');
                $($block).find('.ajax-loading').hide();

            })
            .catch(err => {
                console.error(err);
            });
        return this;
    }

    $(() => {
        $('.ajax-loading').hide();
        $('.funder_carousel').funder();
    })

})($);



// WEBPACK FOOTER //
// ./scripts/components/funder.js